// extracted by mini-css-extract-plugin
export default {"box":"AddClass_box__qnF7L","subjrxt":"AddClass_subjrxt__avwB1","title":"AddClass_title__P2Fe6","grid":"AddClass_grid__jJWVw"};